<template>
  <div v-show="showVideo" class="videoContainer">
    <div @click="exit()" class="close">
      <simpleClose />
    </div>
    <video id="RDS-360Player" class="video-js video-js-vr vjs-default-skin" controls="" playsinline="" width="640" height="300">
    </video>
    <transition
      enterActiveClass="animated fadeIn"
      leaveActiveClass="animated fadeOut"
    >
      <reaction-stripe
        v-show="rbv"
        :player="player360"
        :player-instance="player360"
        :player-state="true"
        :customFS="true"
      />
    </transition>
  </div>
</template>

<script>

import simpleClose from '@/components/glyphs/SimpleClose.vue';

import {
  mapMutations,
  mapState,
} from 'vuex';
import ReactionStripe from '@/components/ReactionStripe.vue';

export default {
  props: ['url', 'token'],
  name: 'Player360',
  components: {
    ReactionStripe,
    simpleClose,
  },
  data() {
    return {
      showVideo: false,
      player360: false,
      rbv: true,
      interval: false,
    };
  },
  mounted() {
    const env = 'special';
    const reactionStripeConfig = {
      ...this.reactionStripeConfig,
      ADS_URL: this.conf[env].ADS_URL,
      appid: this.conf[env].appid,
      service: this.conf[env].service,
      host: this.conf[env].host,
      BASE_GROUP_PHOTO_URL: this.conf[env].BASE_GROUP_PHOTO_URL,
      BASE_SHARE_URL: `${this.conf[env].BASE_SHARE_URL + this.conf[env].appid}/${this.$t('lang')}?id=`,
      TWITTER_TEXT: encodeURI(this.$t('TWITTER_TEXT')),
    };
    console.log(reactionStripeConfig);
    window.start(this.token, reactionStripeConfig);
    window.initBar();
    this.play(this.url);
    this.interval = setInterval(() => {
      this.rbv = this.player360.userActive();
    }, 250);
  },
  methods: {
    ...mapMutations([
      'setRdsPlayer',
      'setRdsPlayer360',
      'setRdsPlayerShow',
      'setRdsPlayer360Show',
    ]),
    exit() {
      this.showVideo = false;
      this.player360.pause();
      this.player360.dispose();
      this.$emit('exit');
    },
    play(url) {
      // eslint-disable-next-line no-multi-assign
      const player360 = window.player360 = window.videojs('RDS-360Player');
      this.player360 = player360;
      this.player360.mediainfo = this.player360.mediainfo || {};
      // player.mediainfo.projection = '360_CUBE';
      this.player360.mediainfo.projection = '360';
      // AUTO is the default and looks at mediainfo
      window.vr = this.player360.vr({ projection: 'AUTO', debug: true, forceCardboard: false });
      this.player360.src({
        type: 'application/x-mpegURL',
        src: url,
      });
      this.player360.play();
      this.showVideo = true;
    },
  },
  computed: {
    ...mapState([
      'reactionStripeConfig',
      'rdsPlayer',
      'rdsPlayer360',
      'rdsPlayerShow',
      'rdsPlayer360Show',
      'conf',
    ]),
  },
};
</script>

<style scoped>
  .videoContainer {
    position: relative;
  }
  .close {
    width: 50px;
    height: 50px;
    position: absolute;
    z-index: 5;
    top: 20px;
    left: 20px;
  }
</style>
